<script setup lang="ts">
import type { ReportFormat, ReportPreview } from '@/modules/reportTemplates/api'

defineProps<{ preview: ReportPreview | null; loading: boolean; error: string; format: ReportFormat }>()
defineEmits<{ retry: [] }>()
</script>

<template>
  <section class="report-preview" aria-label="Предпросмотр документа" :aria-busy="loading">
    <div class="report-preview-heading">
      <div class="d-flex align-center justify-space-between gap-2">
        <h3 class="text-subtitle-1">Предпросмотр</h3>
        <span class="text-caption text-medium-emphasis" role="status">{{ loading ? 'Обновляем…' : error ? 'Не обновлён' : preview ? 'Обновлён' : '' }}</span>
      </div>
      <div class="text-caption text-medium-emphasis mt-1">
        {{ format === 'xlsx' ? 'Содержимое листов Excel. В каждом листе показано до 50 строк.' : 'Содержимое документа. Переносы строк и страницы в файле могут отличаться.' }}
      </div>
      <div v-if="preview?.truncated_text" class="text-caption mt-1">Длинные тексты сокращены только в предпросмотре.</div>
    </div>
    <VProgressLinear :active="loading" indeterminate color="primary" height="2" />
    <div v-if="error" class="pa-4" role="alert">
      <VAlert type="warning" variant="tonal">{{ error }}</VAlert>
      <VBtn class="mt-2" variant="text" size="small" @click="$emit('retry')">Повторить предпросмотр</VBtn>
    </div>
    <div v-else-if="!preview" class="pa-6 text-medium-emphasis">Подготавливаем предпросмотр…</div>
    <iframe
      v-if="preview && !error"
      :srcdoc="preview.html"
      title="Содержимое документа"
      sandbox=""
      referrerpolicy="no-referrer"
      class="report-preview-frame"
      :class="{ 'is-updating': loading }"
    />
  </section>
</template>

<style scoped>
.report-preview { display: flex; flex-direction: column; min-block-size: 0; block-size: 100%; background: rgb(var(--v-theme-surface)); }
.report-preview-heading { padding: 12px 16px; flex-shrink: 0; }
.report-preview-frame { inline-size: 100%; flex: 1 1 0; min-block-size: 0; border: 0; background: #eaf1f5; }
.report-preview-frame.is-updating { opacity: 0.55; }
</style>
